/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PersonalAssetImportTypeEnum {
    Investown = 'investown'
}

export function PersonalAssetImportTypeEnumFromJSON(json: any): PersonalAssetImportTypeEnum {
    return PersonalAssetImportTypeEnumFromJSONTyped(json, false);
}

export function PersonalAssetImportTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetImportTypeEnum {
    return json as PersonalAssetImportTypeEnum;
}

export function PersonalAssetImportTypeEnumToJSON(value?: PersonalAssetImportTypeEnum | null): any {
    return value as any;
}

